import UPMfaResetAction from './UPMfaResetAction';
import { UPMfaResetActionProps } from './types';

export type { UPMfaResetActionProps };

export default UPMfaResetAction;
